export default __webpack_public_path__ + "static/media/envelope-icon.0e93544e.svg";